import { createContext } from "react";

// Theme type used across the app
export type Theme = "light" | "dark";

// Context shape for theme provider and consumers
export interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

// React context providing current theme and toggle helper
export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);
